<template>
  <section class="p-2">
    <v-card>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-row class="px-5">
            <v-form ref="searchform" v-model="valid">
              <v-row class="ms-1 me-1 py-3">
                <v-col cols="12" md="4" lg="4" xs="12">
                  <v-autocomplete
                    v-model="selectedCountry"
                    class="rounded"
                    dense
                    outlined
                    placeholder="Country"
                    item-text="txt"
                    item-value="val"
                    :items="country_options"
                    :rules="countryRules"
                    @input="getPaymentMode"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" lg="4" xs="12">
                  <v-autocomplete
                    v-model="selectedPayment"
                    class="rounded"
                    dense
                    outlined
                    item-text="txt"
                    item-value="val"
                    :items="method_options"
                    placeholder="Payment Mode"
                    :rules="paymentModeRules"
                  ></v-autocomplete>
                </v-col>
                <div class="d-flex">
                  <v-btn
                    depressed
                    small
                    class="text-capitalize me-2 ms-2 text-decoration-none"
                    color="primary"
                    @click="getAllBanks()"
                    >Get Results</v-btn
                  >
                </div>
              </v-row>
            </v-form>
          </v-row>
        </v-card>
      </v-card-text>
      <v-data-table
        fixed-header
        height="55vh"
        :headers="dessertHeaders"
        :items="BankSummary"
        :search="search"
        dense
        item-key="name"
      >
        <template v-slot:item.no_of_branches="{ item }">
          <a class="text-decoration-underline" @click="navBranchList(item)">
            {{ item.no_of_branches }}
          </a>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-btn
              depressed
              x-small
              @click="openBlockDialog(item)"
              color="success"
              title="Unblock user"
              class="text-capitalize me-3"
              v-if="item.is_active"
            >
              Active
            </v-btn>
            <v-btn
              depressed
              x-small
              @click="openBlockDialog(item)"
              color="warning"
              class="text-capitalize me-3"
              title="Block user"
              v-else
            >
              Block
            </v-btn>
            <v-icon
              small
              title="Edit"
              color="primary"
              class="mr-2"
              @click="editItem(item)"
            >
              mdi-content-save-edit-outline
            </v-icon>
          </div>
          <!-- <v-badge color="grey" content="1" small shape="circle"> -->
        </template>

        <template v-slot:top>
          <v-row class="ms-3 me-1 mt-3">
            <div class="d-flex">
              <v-btn
                depressed
                small
                class="text-capitalize text-decoration-none me-2"
                color="primary"
                @click="openDialog"
                ><v-icon small class="me-2">mdi-bank-plus</v-icon>Add
                Bank</v-btn
              >
            </div>
            <v-spacer> </v-spacer>
            <v-spacer> </v-spacer>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              class="me-2"
              color="primary"
              small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4 mb-4"
              dense
              clearable
            ></v-text-field>
          </v-row>
        </template>
      </v-data-table>
      <v-dialog persistent v-model="showDialog" width="800">
        <v-card>
          <v-form ref="Addform" v-model="valid">
            <v-toolbar color="secondary" dark flat dense>
              <span>{{ formtitle }} Bank Details</span>
              <v-spacer></v-spacer>
              <v-btn depressed icon @click="closeDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-row>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Bank Name
                  </label>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    placeholder="Bank Name"
                    v-model="bankDetails.name"
                    :rules="banknameRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize"> Short Name </label>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    placeholder="Short Name"
                    v-model="bankDetails.short_name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Country
                  </label>
                  <v-autocomplete
                    v-model="bankDetails.country_code"
                    class="rounded"
                    dense
                    outlined
                    placeholder="Country"
                    item-text="txt"
                    item-value="val"
                    :items="country_options"
                    :rules="countryRules"
                    @input="getPaymentMode"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Payment Mode
                  </label>
                  <v-autocomplete
                    v-model="bankDetails.payment_mode"
                    class="rounded"
                    dense
                    outlined
                    placeholder="Payment Mode"
                    item-text="txt"
                    item-value="val"
                    :items="method_options"
                    :rules="paymentModeRules"
                  ></v-autocomplete>
                </v-col>
                <!-- <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Bank Code
                  </label>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    placeholder="Bank Code"
                    v-model="bankDetails.bank_code"
                    :rules="bankCodeRules"
                  ></v-text-field>
                </v-col> -->
                <v-divider class="pa-0 ma-0 mb-2"></v-divider>
                <div
                  class="col-md-12"
                  style="
                    display: flex;
                    justify-content: right;
                    margin-top: 8px;
                    margin-bottom: 8px;
                  "
                >
                  <v-btn
                    depressed
                    color="primary"
                    min-width="170px"
                    class="me-5 text-capitalize"
                    @click="onSubmitFor()"
                  >
                    {{ bankDetails.bank_id ? "Update" : "Add" }}
                  </v-btn>

                  <v-btn
                    depressed
                    color="primary"
                    class="text-capitalize"
                    outlined
                    min-width="170px"
                    @click="closeDialog()"
                  >
                    <v-icon small class="me-2">mdi-close-circle-outline</v-icon
                    >Cancel
                  </v-btn>
                </div>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="showBlockDialog" width="500">
        <v-card>
          <v-card-title class="border border-bottom"
            >Update Bank Status</v-card-title
          >
          <v-card-text class="h5 py-3"
            >Are you sure you want to {{ title_text }}?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="confirmBlock(isActive ? false : true)"
            >
              {{ title_text }}<v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="showBlockDialog = false"
            >
              Close<v-icon>mdi-close</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import { FieldRequired } from "@/utils/validation.js";
import setupService from "@/services/SetupService/setupService";
import commonService from "@/services/CommonService/commonService.js";
import alerts from "@/mixins/alerts";
import { masterBankandBranch } from "@/utils/validation.js";
export default {
  mixins: [alerts],
  name: "Master Bank Summary",
  data() {
    return {
      FieldRequired,
      ...masterBankandBranch,
      // expanded: [],
      search: "",
      dialogDelete: false,
      showBlockDialog: false,
      isActive: null,
      blockId: null,
      loader: false,
      showDialog: false,
      valid: true,
      editedIndex: -1,
      title_text: "",
      country_options: [],
      method_options: [],
      selectedCountry: "",
      selectedPayment: "",
      bank_id: null,
      dessertHeaders: [
        {
          text: "Bank Code",
          sortable: false,
          value: "code",
        },
        { text: "Bank Name", value: "name" },
        { text: "Country", value: "country_name" },
        { text: "Payment Mode", value: "payment_mode" },
        { text: "No of Branches", value: "no_of_branches" },
        { text: "Action", value: "action", sortable: false },
      ],
      BankSummary: [],
      bankDetails: {
        name: "",
        short_name: "",
        country_name: "",
        country_code: "",
        payment_mode: "",
        swift_bank: "",
      },
    };
  },
  components: {
    OverlayPageVue,
  },
  mounted() {
    this.getBeneCountryList();
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
  },
  watch: {
    "bankDetails.country_code"(val) {
      this.country_options.map((ele) => {
        if (ele.val === val) {
          this.bankDetails.country_name = ele.txt;
        }
      });
    },
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    async downloadExcelsheet() {
      if (this.BankSummary) {
        this.exportToExcel(
          this.dessertHeaders,
          this.BankSummary,
          "bankSummary"
        );
      }
    },

    async getAllBanks() {
      const validate = this.$refs.searchform.validate();
      if (validate) {
        this.loader = true;
        try {
          const response = await setupService.getAllMasterBanks(
            this.selectedCountry,
            this.selectedPayment
          );
          if (response.data.status_code === 200) {
            this.BankSummary = response.data.data.reverse();
            console.log(this.BankSummary);
            this.stoploader();
          } else if (response.data.status_code === 401) {
            this.BankSummary = [];
          } else {
            this.stoploader();
            this.showAlertError(`Failed: ${response.data.message}`);
            this.BankSummary = [];
          }
          console.log("All Banks", response);
        } catch (e) {
          console.error(e);
          this.showAlertError(
            `Failed: Technical Error please try again later.`
          );
          this.loader = false;
          this.BankSummary = [];
        }
      }
    },
    async getBankById(id) {
      this.loader = true;
      try {
        const response = await setupService.getBankById(id);
        if (response.data.status_code === 200) {
          this.bankDetails = response.data.data[0];
          console.log(this.bankDetails);
          this.stoploader();
        } else {
          this.stoploader();
          this.showAlertError(`Failed: ${response.data.message}`);
        }
        console.log("Bank", response);
      } catch (e) {
        console.error(e);
        this.showAlertError(`Failed: Technical Error please try again later.`);
        this.loader = false;
      }
    },

    editItem(item) {
      this.getBankById(item.bank_id);
      this.showDialog = true;
    },
    openDialog() {
      this.resetBankObj();
      this.showDialog = true;
      this.editedIndex = -1;
      this.selectedCountry
        ? (this.bankDetails.country_code = this.selectedCountry)
        : "";
      this.selectedPayment
        ? (this.bankDetails.payment_mode = this.selectedPayment)
        : "";
      if (this.selectedCountry) {
        this.country_options.map((ele) => {
          if (ele.val === this.selectedCountry) {
            this.bankDetails.country_name = ele.txt;
          }
        });
      }
      if (this.$refs.Addform) {
        this.$refs.Addform.resetValidation();
      }
    },
    resetBankObj() {
      this.bankDetails = {};
    },

    closeDialog() {
      this.loader = false;
      this.showDialog = false;
      this.$refs.Addform.resetValidation();
    },

    onSubmitFor() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        if (this.bankDetails.bank_id) {
          this.update();
        } else {
          this.save();
        }
      }
    },

    async save() {
      this.loader = true;
      try {
        const response = await setupService.AddBankMasterData(this.bankDetails);
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.getAllBanks();
          this.stoploader();
          this.showDialog = false;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.save();
        // }
        else {
          this.showAlertError(response.data.message);
          this.loader = false;
        }
        console.log("saved Data", response);
      } catch (e) {
        console.error(e);
        this.showAlertError(`Failed: Technical Error please try again later.`);
        this.loader = false;
      }
    },
    async update() {
      this.loader = true;
      try {
        const response = await setupService.updateBankMasterData(
          this.bankDetails.bank_id,
          this.bankDetails
        );
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.getAllBanks();
          this.showDialog = false;
          this.stoploader();
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.save();
        // }
        else {
          this.showAlertError(response.data.message);
          this.loader = false;
        }
        console.log("update Data", response);
      } catch (e) {
        console.error(e);
        this.showAlertError(`Failed: Technical Error please try again later.`);
        this.loader = false;
      }
    },

    async getBeneCountryList() {
      this.loader = true;
      try {
        const responseData = await commonService.getCountryBirthList();
        console.log(responseData);
        this.loader = false;
        if (responseData.data.status_code === 200) {
          this.country_options = responseData.data.data.map((i) => {
            return {
              txt: i.country_name,
              val: i.iso_alpha3,
            };
          });
        }
        console.log("getBeneCountryList", responseData);
      } catch (e) {
        this.loader = false;
        console.error(e);
      }
    },

    async getPaymentMode() {
      this.loader = true;
      this.bankDetails.country_code
        ? (this.selectedCountry = this.bankDetails.country_code)
        : "";
      const selectedCountry = this.country_options.find(
        (item) => item.val === this.bankDetails.country_code
      );
      selectedCountry
        ? (this.bankDetails.country_name = selectedCountry.txt)
        : "";
      console.log(this.bankDetails.country_name);
      try {
        const responseData = await setupService.getPaymentByCountry(
          this.selectedCountry
        );
        this.loader = false;
        if (responseData.data.status_code === 200) {
          this.method_options = responseData.data.data.map((i) => {
            return {
              txt: i.payment_mode.value,
              val: i.payment_mode.value_code,
            };
          });
        } else {
          this.method_options = [];
        }
        console.log("getPaymentMode", responseData);
      } catch (e) {
        this.loader = false;
        console.error(e);
      }
    },

    navBranchList(item) {
      this.$router.push({
        name: "MasterBranch Summary",
        query: { bank_id: item.bank_id, country: item.country_code },
      });
    },
    openBlockDialog(item) {
      console.log(item);
      this.title_text = item.is_active ? "Block" : "Active";
      this.showBlockDialog = true;
      this.isActive = item.is_active;
      this.blockId = item.bank_id;
    },
    async confirmBlock(is_active) {
      this.loader = true;
      try {
        const response = await setupService.updateBankStatus(
          this.blockId,
          is_active
        );
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.getAllBanks();
          this.showBlockDialog = false;
          this.stoploader();
        } else {
          this.showAlertError(response.data.message);
          this.loader = false;
        }
        console.log("update Data", response);
      } catch (e) {
        console.error(e);
        this.showAlertError(`Failed: Technical Error please try again later.`);
        this.loader = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.width-anchor {
  width: 200px !important;
}

.required:after {
  content: " *";
  color: red;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
